/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import HeaderComponent from "./partials/HeaderComponent";
import FooterComponent from "./partials/FooterComponent";
import EditorComponent from "./partials/EditorComponent";
import CoinImg from "../assets/img/coin.png";
import { Nav, NavItem, TabContent, TabPane, NavLink, Row } from "reactstrap";
import { Redirect, Link as RouterLink } from "react-router-dom";
import "./css/problemSolving.css";
import "font-awesome/css/font-awesome.min.css";
import parse from "html-react-parser";
import axios from "axios";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";
import { connect } from "react-redux";
import { LOGIN, LOGOUT } from "../Pages/ReduxStore/slices/authSlice";
import Spinner from "../Pages/MerchandiseStore/Spinner/Spinner";
import Disqus from "disqus-react";

const verdict = {
  AC: '<span class="text-success"><span class="fa fa-check-circle"></span> Accepted</span>',
  WA: '<span class="text-danger"><span class="fa fa-times-circle"></span> Wrong Answer</span>',
  TLE: '<span class=""><span class="fa fa-hourglass-end"></span> Time Limit Exceeded</span>',
  RE: '<span class="text-danger">Runtime Error</span>',
  CE: '<span class="text-danger">Compiletime Error</span>',
};

class Submissions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submissions: [],
    };
  }
  componentDidMount() {
    this.getSubmissions();
  }

  getSubmissions = async () => {
    try {
      // console.log("trying");
      const res = await axios.post(
        `https://server.codeium.tech/problem/submissions`,
        {
          username: JSON.parse(localStorage.getItem("Codeium__Username")),
          problem_id: this.props.problemId,
        }
      );
      this.setState({ submissions: res.data.msg });
    } catch (err) {
      this.setState({ submissions: {} });
    }
  };
  render() {
    return (
      <div className="pt-4">
        <table class="table table-borderless submission-table">
          <thead class="thead-light">
            <tr>
              <th scope="col">Result</th>
              <th scope="col">Language</th>
              <th scope="col">Time</th>
            </tr>
          </thead>
          <tbody className="tab-container-body">
            {this.state.submissions.map((submission) => {
              let styles = {};
              let styleclass = "";
              if (
                submission.verdict === "WA" ||
                submission.verdict === "RE" ||
                submission.verdict === "CE"
              ) {
                styleclass = "table-danger";
                styles = { backgroundColor: "#f5c6cb" };
              } else if (submission.verdict === "AC") {
                styleclass = "table-success";
                styles = { backgroundColor: "#c3e6cb" };
              } else if (submission.verdict === "TLE") {
                styleclass = "table-warning";
                styles = { backgroundColor: "#fff1c8" };
              }
              return (
                <tr
                  // className={styleclass}
                  style={styles}
                >
                  <td>{parse(verdict[submission.verdict])}</td>
                  <td>{submission.language}</td>
                  <td>
                    {new Date(submission.submission_time).toLocaleTimeString(
                      [],
                      {
                        month: "short",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                      }
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

class Editorial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLocked: true,
      editorial: "",
    };
  }
  componentDidMount() {
    this.getEditorial();
  }
  getEditorial = async () => {
    try {
      const res = await axios.get(
        `https://server.codeium.tech/problem/editorial`,
        {
          params: {
            contest_id: this.props.contestId,
            problem_id: this.props.problemId,
          },
        }
      );
      // console.log(res.data);
      if (res.data.status == 200) {
        this.setState({
          editorial: res.data.msg[0].problem_solution,
          isLocked: false,
        });
      } else {
        this.setState({ isLocked: true });
      }
    } catch (err) {
      // console.log(err);
      this.setState({ isLocked: true });
    }
  };

  render() {
    const disqusShortname = "codeium";
    const disqusConfig = {
      url:
        "http://localhost:3000" +
        "/contests/" +
        this.props.contestId +
        "/problem/" +
        this.props.problemId,
      identifier:
        "/problem/" + this.props.problemId + "contests/" + this.props.contestId,
      title: this.props.problemId,
    };
    if (this.state.isLocked) {
      return (
        <div className="pt-3" style={{ fontSize: "15px" }}>
          <h5 className="w-100 text-center pt-5 pb-4">
            <span class="fa fa-lock"></span> Editorial will be added later.
          </h5>
        </div>
      );
    } else {
      return (
        <>
          <div className="pt-3" style={{ fontSize: "15px" }}>
            <div className="py-2">
              <p className="pl-2">
                <span style={{ whiteSpace: "pre-line" }}>
                  <Latex>
                    {this.state.editorial ? this.state.editorial : ""}
                  </Latex>
                </span>
              </p>
            </div>
            <Disqus.DiscussionEmbed
              shortname={disqusShortname}
              config={disqusConfig}
            />
          </div>
        </>
      );
    }
  }
}

const difficulty = {
  1: '<span class="details text-bold" style="color:#b434eb"> Cake Walk</span>',
  2: '<span class="text-primary details text-bold"> Easy</span>',
  3: '<span class="text-success details text-bold"> Medium</span>',
  4: '<span class="text-warning details text-bold"> Hard</span>',
  5: '<span class="text-danger details text-bold"> Miscellaneous</span>',
};
class ProblemSubmission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      isModalOpen: false,
      contestEnded: false,
      timeRemaining: "00:00:00",
      loading: false,
      practiceAllowed: false,
      problemData: {
        problem_id: "",
        problem_title: "",
        coins: "",
        difficulty_level: "",
        prob_desc: "",
        prob_input: "",
        prob_output: "",
        prob_constraint: "",
        currTime: "",
        endTime: "",
        testcase: [
          {
            input: "",
            output: "",
          },
        ],
        tags: [{ tag: "" }],
        prob_explaination: "",
      },
    };
    this.toggleActiveTab = this.toggleActiveTab.bind(this);
  }
  toggleActiveTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };
  async componentDidMount() {
    this.setState({ loading: true });
    let currTime = new Date().getTime();
    await axios
      .get("https://server.codeium.tech/time")
      .then((res) => {
        // console.log("time: ", res);
        // console.log("time: ", new Date(res.data.time).getTime());
        currTime = new Date(res.data.time).getTime();
        this.setState({ currTime: new Date(res.data.time).getTime() });
      })
      .catch((err) => {
        // console.log(err);
      });
    let startTime = new Date().getTime();
    await axios
      .post("https://server.codeium.tech/contest/endtime", {
        username: this.props.username,
        contest_id: this.props.match.params.contestId,
      })
      .then((res) => {
        startTime = new Date(res.data.msg[0].start_time).getTime();
        var endTime = new Date(res.data.msg[0].end_time).getTime();
        // console.log(res);
        if (startTime > currTime) {
          // console.log("Yes");
          this.props.history.push("/contests");
        } else if (endTime && (currTime - endTime) / 36e5 >= 1) {
          this.setState({
            practiceAllowed: true,
          });
        }
      })
      .catch((err) => {
        // console.log(err);
      });
    if (!this.state.practiceAllowed) {
      await axios
        .post(`https://server.codeium.tech/contest/paid/transaction`, {
          username: JSON.parse(localStorage.getItem("Codeium__Username")),
          contest_id: this.props.match.params.contestId,
        })
        .then((res) => {
          // console.log(res);
          // console.log(res.data);
          if (res.data.status === 200) {
            if (res.data.msg["ispaid"] !== "Success")
              this.props.history.push("/contests");
          } else {
            // console.log(res);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }
    await axios
      .post(`https://server.codeium.tech/practice/` + this.problemId, {
        username: this.props.username,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.status === 200) {
          this.setState({ problemData: res.data.msg[0] });
        } else {
          // console.log("this");
          this.props.history.push("/contests");
          // console.log(res);
        }
      })
      .catch((err) => {
        // console.log(err);
      });
    this.setState({ loading: false });

    //Timer
    await axios
      .post("https://server.codeium.tech/contest/endtime", {
        username: this.props.username,
        contest_id: this.props.match.params.contestId,
      })
      .then((res) => {
        this.setState({
          endTime: new Date(res.data.msg[0].end_time).getTime(),
        });
        // console.log(res);
        // console.log(res.data.msg);
        let endTime = new Date(res.data.msg[0].end_time).getTime();
        // console.log(new Date(endTime), new Date(currTime));
        let timeleft = endTime - currTime;
        let interval = setInterval(() => {
          if (timeleft < 0) {
            this.setState({
              contestEnded: true,
            });
            clearInterval(interval);
          } else {
            let hours = Math.floor(
              (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            let minutes = Math.floor(
              (timeleft % (1000 * 60 * 60)) / (1000 * 60)
            );
            let seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

            hours = "0" + hours.toFixed(0);
            minutes = "0" + minutes.toFixed(0);
            seconds = "0" + seconds.toFixed(0);
            this.setState({
              timeRemaining:
                hours.slice(-2) +
                ":" +
                minutes.slice(-2) +
                ":" +
                seconds.slice(-2),
            });
            timeleft -= 1000;
          }
        }, 1000);
      })
      .catch((err) => {
        // console.log(err);
      });
  }
  contestId = this.props.match.params.contestId;
  problemId = this.props.match.params.problemId;
  render() {
    const ProblemStatement = () => {
      return (
        <div className="pt-3" style={{ fontSize: "15px" }}>
          <div className="py-2">
            <h6>
              <b>Problem Description</b>
            </h6>
            <p className="pl-2">
              <span style={{ whiteSpace: "pre-line" }}>
                <Latex>
                  {this.state.problemData.prob_desc
                    ? this.state.problemData.prob_desc
                    : ""}
                </Latex>
              </span>
            </p>
          </div>
          <hr className="mt-0" />
          <div className="py-2">
            <h6>
              <b>Input </b>
            </h6>
            <p className="pl-2">
              <span style={{ whiteSpace: "pre-line" }}>
                <Latex>
                  {this.state.problemData.prob_input
                    ? this.state.problemData.prob_input
                    : ""}
                </Latex>
              </span>
            </p>
          </div>
          <hr className="mt-0" />
          <div className="py-2">
            <h6>
              <b>Output </b>
            </h6>
            <p className="pl-2">
              <span style={{ whiteSpace: "pre-line" }}>
                <Latex>
                  {this.state.problemData.prob_output
                    ? this.state.problemData.prob_output
                    : ""}
                </Latex>
              </span>
            </p>
          </div>
          <hr className="mt-0" />
          <div className="py-2">
            <h6>
              <b>Problem Constraints</b>
            </h6>
            <p className="pl-2">
              <span style={{ whiteSpace: "pre-line" }}>
                <Latex>
                  {this.state.problemData.prob_constraint
                    ? this.state.problemData.prob_constraint
                    : ""}
                </Latex>
              </span>
            </p>
          </div>
          <hr className="mt-0" />
          <div className="py-2">
            <h6>
              <b>Sample Test Cases</b>
            </h6>
            <p className="">
              <ul className="pl-4">
                {this.state.problemData.testcase.map((testcase, index) => {
                  return (
                    <li key={index + 1} className="py-2">
                      <h7>
                        <b>{"Test Case " + (index + 1) + " : "}</b>
                      </h7>
                      <br />
                      <span>Input :</span>
                      <br />
                      <span style={{ whiteSpace: "pre-line" }}>
                        {testcase.input}
                      </span>
                      <br />
                      <span>Output :</span>
                      <br />
                      <span style={{ whiteSpace: "pre-line" }}>
                        {testcase.output}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </p>
          </div>
          <hr className="mt-0" />
          <div className="py-2">
            <h6>
              <b>Explaination</b>
            </h6>
            <p className="pl-2">
              <span style={{ whiteSpace: "pre-line" }}>
                <Latex>
                  {this.state.problemData.prob_explaination
                    ? this.state.problemData.prob_explaination
                    : ""}
                </Latex>
              </span>
            </p>
          </div>
        </div>
      );
    };
    try {
      return (
        <div className="">
          <HeaderComponent />
          {this.state.loading ? (
            <Spinner />
          ) : (
            <div className="page-wrapper">
              <br />
              <br />
              <div className="container">
                <div className="row">
                  <nav>
                    <ol class="breadcrumb bg-transparent pb-1">
                      <li
                        class="breadcrumb-item underline"
                        style={{ textDecoration: "underline" }}
                      >
                        <a style={{ color: "black" }} href="/contests">
                          Contests
                        </a>
                      </li>
                      <li
                        class="breadcrumb-item underline"
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        {/* href={"/contests/" + this.props.match.params.contestId}  */}
                        <a
                          onClick={() =>
                            this.props.history.push(
                              "/contests/" + this.props.match.params.contestId
                            )
                          }
                        >
                          {this.props.match.params.contestId}
                        </a>
                      </li>
                      <li
                        class="breadcrumb-item "
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        <a onClick={() => this.props.history.goBack()}>
                          Problems
                        </a>
                      </li>
                      <li class="breadcrumb-item active">
                        {this.state.problemData.problem_title}
                      </li>
                    </ol>
                  </nav>
                </div>
                <div className="row">
                  <div className="col-12">
                    <h1 className="primary-heading">
                      {this.state.problemData.problem_title}{" "}
                    </h1>
                  </div>
                  <div className="col-12">
                    <div className="py-2 py-md-0 pr-3 d-inline">
                      <span className="field">
                        <b>DIFFICULTY :</b>
                      </span>
                      {parse(
                        difficulty[this.state.problemData.difficulty_level] ||
                          ""
                      )}
                    </div>
                    <div className="py-2 py-md-0 pr-3 d-inline">
                      <span className="field">
                        <b>COINS :</b>
                      </span>
                      <span className="details">
                        {" "}
                        {this.state.problemData.coins}{" "}
                        <img src={CoinImg} className="Cart_CoinImg" />
                      </span>
                    </div>
                  </div>
                  <div className="col-12">
                    <hr width="100%" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-9 ">
                    <div className="">
                      <div className=" tab-container">
                        <div className="d-flex justify-content-center ">
                          <Nav
                            tabs
                            className="row w-100 d-flex align-items-center justify-content-center"
                          >
                            <NavItem className="col-4 text-center px-0 tablinks">
                              <NavLink
                                className={
                                  this.state.activeTab == "1" ? "active" : ""
                                }
                                onClick={() => {
                                  this.toggleActiveTab("1");
                                }}
                              >
                                Problem
                              </NavLink>
                            </NavItem>
                            <NavItem className="col-4 text-center px-0 tablinks">
                              <NavLink
                                className={
                                  this.state.activeTab == "2" ? "active" : ""
                                }
                                onClick={() => {
                                  this.toggleActiveTab("2");
                                }}
                              >
                                Submissions
                              </NavLink>
                            </NavItem>
                            <NavItem className="col-4 text-center px-0 tablinks">
                              <NavLink
                                className={
                                  this.state.activeTab == "3" ? "active" : ""
                                }
                                onClick={() => {
                                  this.toggleActiveTab("3");
                                }}
                              >
                                Editorial
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </div>
                        <TabContent
                          className="container px-md-4 pb-4"
                          activeTab={this.state.activeTab}
                        >
                          <TabPane tabId="1">
                            <ProblemStatement />
                            <hr
                              className="mt-0"
                              style={{
                                borderWidth: "0px",
                                height: "2px",
                                color: "rgb(0,0,0,0.1)",
                                backgroundColor: "rgb(0,0,0,0.1)",
                              }}
                            />
                            <br />
                            <br />
                            <EditorComponent
                              contestId={this.contestId}
                              problemId={this.problemId}
                            />
                          </TabPane>
                          <TabPane tabId="2">
                            <Submissions
                              username={this.props.username}
                              problemId={this.problemId}
                            />
                          </TabPane>
                          <TabPane tabId="3">
                            <Editorial
                              contestId={this.contestId}
                              problemId={this.problemId}
                              problemName={this.state.problemData.problem_title}
                            />
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 d-none d-md-block">
                    {!this.state.contestEnded ? (
                      <>
                        <div className="card bg-light py-2 px-3">
                          <h5 className="text-center mt-2 card-title font-weight-bold">
                            Contest Ends in
                          </h5>
                          <h5 className=" text-center card-subtitle">
                            {this.state.timeRemaining}
                          </h5>
                        </div>
                      </>
                    ) : (
                      <div className="row">
                        <div className="col-12 text-center">
                          <span className="field ">
                            <b>TOPICS</b>
                          </span>
                          <br />
                          {this.state.problemData.tags.map((topic) => {
                            return (
                              <span className="badge badge-pill badge-warning mx-2">
                                {topic.tag}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <br />
            </div>
          )}
          <FooterComponent />
        </div>
      );
    } catch {
      return <Redirect to="/404Page" />;
    }
  }
}
const mapStateToProps = (state) => {
  return {
    username: state.auth.username,
    isAuthenticated: state.auth.isAuthenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxLogin: (username) => dispatch(LOGIN(username)),
    reduxLogout: () => dispatch(LOGOUT()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProblemSubmission);

// problemData: {
//   "problem_id": "1",
//     "problem_title": "QUESTION NAME",
//       "coins": "15",
//         "difficulty_level": "5",
//           "prob_desc": "Chef is playing a game where he has an array $\\mathit{A}$ of $\\mathit N$ integers, and an integer $\\mathit K$. He looks at every subarray of length $\\mathit K$, and writes its sum on a piece of paper. If a number appears as the sum of multiple subarrays of length $\\mathit K$, then he only writes down that number once. Chef is lazy and doesn't like to write numbers. \n\nYou, being a friend of Chef, want to modify the array such that Chef will only write one number on his paper. In one modification you can choose any index $\\mathit i$ and replace $A_i$ with any integer.\n\n You need to find the minimum number of modifications required.",
//             "prob_input": "The first line contains an integer $\\mathit T$, the number of test cases. \nThen the test cases follow. \nEach test case contains two lines of input. \nThe first line contains two space-separated integers $\\mathit N, K$.\nThe second line contains $\\mathit N$ space-separated integers $\\mathit A_1,A_2,…,A_N$",
//               "prob_output": "For each test case, output the answer in a single line.",
//                 "prob_constraint": "$ 1 \\le T \\le 1000$ \n $ 1 \\le N \\le 10^ 5$ \n $ 1 \\le K \\le N $ \n $ 1 \\le A_i \\le 10^ 5 $ \n $\\text{The sum of $N$ over all test cases does not exceed $5⋅10^ 5$}$ ",
//                   "testcase": [
//                     {
//                       "input": "1\n4 5",
//                       "output": "9\n"
//                     },
//                     {
//                       "input": "1\n1 0",
//                       "output": "1\n"
//                     }
//                   ]
// }
//
